<template>
  <div>
    <a
      class="button p-3 flex items-center rounded-full cursor-pointer"
      :class="wasRecentlyReleased ? 'action' : 'action-secondary'"
      :href="data.route"
      target="_blank"
    >
      <span class="text-3xl text-l pr-2">
        <font-awesome-icon :icon="icon" />
      </span>
      <span class="flex flex-col text-center pr-3 text-gray-900">
        <span class="font-bold" v-text="data.labels.download_for"></span>
        <span class="text-gray-700 text-sm">Version {{ data.version }}</span>
      </span>
    </a>
    <p
      v-if="wasRecentlyReleased"
      class="text-center font-bold text-sm text-orange-700"
    >
      {{ data.labels.last_update }}
    </p>
  </div>
</template>

<script>
export default {
  props: ["data"],
  computed: {
    icon() {
      return ["fab", this.data.os === "win" ? "windows" : "apple"];
    },
    os() {
      return this.data.os === "win" ? "Windows" : "Mac";
    },
    wasRecentlyReleased() {
      if (this.data.days_since_release > 45) {
        return false;
      }
      const userPlatform =
        navigator.platform.indexOf("Mac") > -1 ? "mac" : "win";
      return this.data.os === userPlatform;
    },
  },
};
</script>
